<div class="container group-classes-calendar-container mb-3">
    <app-calendar-settings *ngIf="searchForm && model" [searchForm]="searchForm" [model]="model"></app-calendar-settings>

    <div class="mt-3">
        <app-classes-calendar [clubId]="clubId"></app-classes-calendar>
    </div>
</div>
